import { useMemo } from 'react';
import { getQuarterFromMonth, createQuarterlyData } from './useQuarterHelpers';

/**
 * Calcul du CA total et par consultant
 */
export function useCACalculations(tempsData) {
  // CA total par trimestre
  const caTotal = useMemo(() => {
    const result = createQuarterlyData();

    tempsData.forEach(temps => {
      const month = temps.fields?.Mois;
      if (!month) return;

      const quarter = getQuarterFromMonth(month);
      const montant = (temps.fields?.['Nombre de jours'] || 0) *
                      (temps.fields?.['Taux journalier (€)'] || 0);

      result[quarter] += montant;
      result.ANNUEL += montant;
    });

    return result;
  }, [tempsData]);

  // CA par consultant
  const caByConsultant = useMemo(() => {
    const result = {};

    tempsData.forEach(temps => {
      const consultant = temps.consultantNom;
      if (!consultant) return;

      if (!result[consultant]) {
        result[consultant] = createQuarterlyData();
      }

      const month = temps.fields?.Mois;
      if (!month) return;

      const quarter = getQuarterFromMonth(month);
      const montant = (temps.fields?.['Nombre de jours'] || 0) *
                      (temps.fields?.['Taux journalier (€)'] || 0);

      result[consultant][quarter] += montant;
      result[consultant].ANNUEL += montant;
    });

    return result;
  }, [tempsData]);

  const consultants = useMemo(() => Object.keys(caByConsultant), [caByConsultant]);

  return { caTotal, caByConsultant, consultants };
}
